import { DomainSchema } from '@multitec/domain'
import { useQuery } from 'react-query'
import { z } from 'zod'

import { Base } from '../base'
import { MyURLSearchParams } from '../utils/url-search-params'

const BASE_URL = '/entity/orders'

// class Create extends Base {
//   private body = DomainSchema.Storage.pick({
//     name: true,
//     description: true,
//     active: true,
//   })

//   private response = DomainSchema.Storage

//   handle = async (body: z.infer<typeof this.body>) => {
//     const { data } = await this.axios.post(BASE_URL, body)
//     return this.response.parse(data.result)
//   }
// }

// class Update extends Base {
//   private body = DomainSchema.Storage.pick({
//     name: true,
//     description: true,
//     active: true,
//   })

//   private response = DomainSchema.Storage

//   handle = async (id: string, body: z.infer<typeof this.body>) => {
//     const { data } = await this.axios.put(`${BASE_URL}/${id}`, body)
//     return this.response.parse(data.result)
//   }
// }

class Search extends Base {
  private searchParams = z.object({
    search: z.string().optional(),
    type: z.enum(['SERVICO', 'VENDA']).optional(),
    status: z
      .array(
        z.enum([
          'all',
          'OPEN',
          'FIM_ORCAMENTO',
          'APPROVED',
          'DOING',
          'DONE',
          'CLOSED',
          'REPROVED',
          'CANCELED',
        ]),
      )
      .optional(),
    tipoEquipamento: z.enum(['all', 'EQUIPAMENTO', 'PATRIMONIO']).optional(),
    userId: z.string().optional(),
  })

  private response = z.array(DomainSchema.Order)

  handle = (searchParams: z.infer<typeof this.searchParams>) => {
    return useQuery(['order', 'search', { ...searchParams }], async () => {
      const queryParams = new MyURLSearchParams(searchParams).toString()
      const { data } = await this.axios.get(BASE_URL + `?${queryParams}`)
      return this.response.parse(data.result)
    })
  }
}

class LoadOne extends Base {
  private response = DomainSchema.Order

  handle = (id?: string | number | null) => {
    return useQuery(['order', 'load-one', { id }], async () => {
      if (!id) return null

      const { data } = await this.axios.get(`${BASE_URL}/${id}`)
      return this.response.parse(data.result)
    })
  }
}

export default class extends Base {
  // Create = new Create(this.axios).handle
  // Update = new Update(this.axios).handle
  Search = new Search(this.axios).handle
  LoadOne = new LoadOne(this.axios).handle
}
